<template>
    <div v-if="spinner==true" class="spinner"></div>
    <div :class="spinner == true?'difuminado':''">
        <div class="card">
            <div class="card-header">
                <p class="card-title"> Informe Verifactu</p>
            </div>
            <div class="card-body">
                    <div class="row"> 
                        <div class="col-md-4">
                            <label for="">Empresas</label>
                            <select v-model="empresaselec" class="form-control" name="" id="empr">
                                <option value="">Todas</option>
                                <option v-for="empr in empresas" :key="empr.id" :value="empr.id">{{ empr.nombre_empresa }}</option>
                            </select>
                        </div>    
                        <div class="col-md-3">
                            <label for="">Estado</label>
                            <input type="text" data-rule-dateita="true" class="form-control pull-right" v-model="estado" name="estado">
                        </div>    
                        <div class="col-md-4 row" style="gap: 30px;">
                            <div>
                                <label for="">Fecha inicio</label>
                                <input class="form-control" type="date" v-model="fecha_inicio">
                            </div>
                            <div>
                                <label for="">Fecha fin</label>
                                <input class="form-control" type="date" v-model="fecha_fin">
                            </div>
                            <div>
                            <button @click="obtenerInforme()" class="btn btn-sm btn-primary" style="margin-top: 58%" >Mostrar</button>
                            </div>
                        </div> 
                                               
                    </div>
            </div>
        </div>
        <div class="card" v-if="informe">
            <div class="card-body">
                <button @click="exportarcsv()" class="btn btn-sm btn-primary">Descargar Excel</button>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        Empresa
                                    </th>
                                    <th>
                                        Fecha/hora
                                    </th>
                                    <th>
                                        Envío
                                    </th>
                                    <th>
                                        Respuesta
                                    </th>
                                    <th>
                                        Estado
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="linea in informe" :key="linea.id_registro">
                                    <td>
                                        <span v-if="empresas.find(empresa => empresa.id_empresa == linea.id_empresa)">{{  empresas.find(empresa => empresa.id_empresa == linea.id_empresa).nombre_empresa }}</span>
                                    </td>
                                    <td>
                                        {{new Date(linea.fecha_hora * 1000).toLocaleString("es-es", { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }) }}
                                    </td>
                                    <td>
                                        {{ linea.envio }}
                                    </td>
                                    <td>
                                        {{ decode_utf8(linea.respuesta) }}
                                    </td>
                                    <td>
                                        {{ linea.estado }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
            </div>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../services/PwgsApi';
import jsonToCsvExport from "json-to-csv-export";

export default{    
    data(){
        return {
            empresas: [],
            empresaselec: '',
            estado: '',
            fecha_inicio: '',
            fecha_fin: '',
            informe:'',
        }
    },
    methods: {
        async obtenerEmpresas(){
            const api = new PwgsApi();            
            this.empresas = await api.get('empresas/todas');
        },
        async obtenerInforme() {
            this.informe = '';
            const api = new PwgsApi();
            let subidadatos = {id_empresa: this.empresaselec, estado: this.estado, fecha_inicio: this.fechaesp(this.fecha_inicio), fecha_fin: this.fechaesp(this.fecha_fin)}
            this.informe = await api.post('informes/verifactu', subidadatos);
        },
        fechaing(fecha) {
        const [dia, mes, año] = fecha.split("/");
        return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        },
        fechaesp(fecha) {
        const [año, mes, dia] = fecha.split("-");
        return `${dia}/${mes}/${año}`;
        },
         fechaActual() {
        const hoy = new Date();
        this.fecha_inicio = this.fechaing(hoy.toLocaleDateString());
        this.fecha_fin = this.fechaing(hoy.toLocaleDateString());
        },
          decode_utf8(s) {
            try{
            return decodeURIComponent(escape(s));
            }
            catch(error){
                console.log(error);
                return s;
            }
        },
        async exportarcsv() {
           try{
                this.$toast.add({ severity: 'success', summary: 'Descarga iniciada', detail: 'Descargando...', life: 5000 });               
               
                let filtrados = this.informe;
                var listado = [];
                filtrados.forEach(filtrado => {
                    let csv = {};
                    csv['Empresa'] = this.empresas.find(empresa => empresa.id_empresa == filtrado.id_empresa).nombre_empresa;
                    csv['Fecha/hora'] = new Date(filtrado.fecha_hora * 1000).toLocaleString("es-es", { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' });
                    csv['Envio'] = filtrado.envio;
                   /* const encodedText = filtrado.pendiente;

                    // Convertimos el texto a un buffer de bytes interpretado como ISO-8859-1
                    const bytes = new Uint8Array([...encodedText].map(char => char.charCodeAt(0)));

                    // Usamos TextDecoder para decodificar correctamente como UTF-8
                    const decoder = new TextDecoder('utf-8');
                    const decodedText = decoder.decode(bytes);

                    csv['Pendiente de'] = decodedText;*/
                    csv['Respuesta'] = filtrado.respuesta;
                   
                    csv['Estado'] = filtrado.estado;
                    listado.push(csv);
                });
                
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: listado, filename: 'InformeVerifactu_' + fechahoy,delimiter:";" });      
           }catch (e) {                
               this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
           }
            //let text = "hola mondo";
           
        },

    },
      mounted(){
          this.obtenerEmpresas();
          this.fechaActual();
    },
}
</script>